// Import Services
import { Helpers } from 'services';
// Import Hooks
import { usePartnerDateFormats } from 'hooks/UsePartnerDateFormats';
// Import Constants
import { l } from 'constants/common';

const { customMomentWithoutTimezoneConversion, getSafeHttpUrl } = Helpers;

const PlayersColumns = (t) => {
    const { partnerDateTimeFormat } = usePartnerDateFormats();
    return {
        columns: [
            {
                text: t(l.ActionDate),
                dataKey: 'ActionDate',
                sortable: true,
                formatter: (ActionDate) => {
                    return (
                        ActionDate && customMomentWithoutTimezoneConversion(ActionDate).format(partnerDateTimeFormat)
                    );
                },
            },
            {
                text: t(l.Country),
                dataKey: 'Country',
                sortable: true,
            },
            {
                text: t(l.Currency),
                dataKey: 'Currency',
                sortable: true,
            },
            {
                text: t(l.ClientId),
                dataKey: 'ClientId',
                sortable: true,
            },
            {
                text: t(l.Gender),
                dataKey: 'Gender',
                sortable: true,
            },
            {
                text: t(l.FirstName),
                dataKey: 'FirstName',
                sortable: true,
            },
            {
                text: t(l.LastName),
                dataKey: 'LastName',
                sortable: true,
            },
        ],
    };
};

const TrackedLinksColumnsConfigs = (t) => {
    return {
        columns: [
            {
                text: t(l.Url),
                dataKey: 'Url',
                sortable: true,
                colRenderer: (Url) => {
                    // Tracked links are taken from template bodies written by users: only http(s) becomes a link
                    const safeUrl = Url === 'UnsubscribeLink' ? undefined : getSafeHttpUrl(Url);

                    return safeUrl ? (
                        <a href={safeUrl} target="_blank" rel="noopener noreferrer">
                            <span>{Url}</span>
                        </a>
                    ) : (
                        <span>{Url}</span>
                    );
                },
            },
            {
                text: t(l.ClickedCount),
                dataKey: 'ClickedCount',
                sortable: true,
            },
        ],
        multiSelectColumnConfig: {
            sizeParams: {
                defaultCustomWidth: 54,
            },
        },
    };
};

export { PlayersColumns, TrackedLinksColumnsConfigs };
